// export const tableDateFormat = 'MMM DD, YYYY h:mm A (UTC)' //AM PM
export const tableDateFormat = 'MMM DD, YYYY HH:mm (UTC)'

/**
 * Default country code for phone numbers
 */
export const DEFAULT_COUNTRY_CODE = 'IL'

/**
 * Sentinel value for the organization filter that selects users with no
 * active organization ("orphaned" users). Must match the backend literal.
 */
export const NO_ORGANIZATION_FILTER_VALUE = 'NO_ORGANIZATION'

/**
 * Token types for JWT authentication
 */
export const TOKEN_TYPE_SUPER_ADMIN_LOGIN = 'super_admin_login'

export const AutomationTypes = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
    WHATSAPP: 'WHATSAPP'
}

export const AutomationSubTypes = {
    COURSE_TO_FINISH_REMINDER: 'COURSE_TO_FINISH_REMINDER',
    DOC_TO_SIGN_REMINDER: 'DOC_TO_SIGN_REMINDER'

}

export const FeatureFlags = {
    AUTOMATION: 'automationFF',
    SMS: 'smsFF',
    EMAIL: 'emailFF',
    WHATSAPP: 'whatsappFF',
    SIGN_DOCS_READ_AND_SIGN_DOC_PDF: 'signDocsReadAndSignDocPdfFF',
    SIGN_DOCS_WATCH_AND_SIGN_YOUTUBE_LINK: 'signDocsWatchAndSignYoutubeLinkFF',
    SIGN_DOCS_WATCH_AND_SIGN_VIMEO_LINK: 'signDocsWatchAndSignVimeoLinkFF',
    SIGN_DOCS_WATCH_AND_SIGN_VIDEO_FILE: 'signDocsWatchAndSignVideoFileFF',
    SIGN_DOCS_AUDIO_FILE: 'signDocsAudioFileFF',
    SIGN_DOC_REGULAR_COURSE: 'regularCourseFF',
    SEND_WELCOME_MESSAGE: 'sendWelcomeMessageFF',
    NOTIFY_NEW_TASK_TO_USER: 'notifyNewTaskToUserFF',
    KNOWLEDGE_CENTER: 'knowledgeCenterFF',
    ORG_ADMIN_MGMT: 'orgAdminMgmtFF',
    SUB_ADMIN_CAN_CREATE_ORG: 'subAdminCanCreateOrgFF',
    SIGN_DOC_CANVA_PRESENTATION: 'signDocCanvaPresentationFF',
    LANGUAGES: 'languagesFF',
    EXAM: 'examsFF',
    WEEZBEE_COURSE: 'weezbeeCourseFF',
    AI: 'AIFF',
    LEARNING_PATH: 'learningPathFF',
    LINK: 'linkFF',
    SURVEYS: 'surveyFF',
    RECURRING_AUTOMATION: 'recurringAutomationFF',
    UPLOAD_DOCUMENT: 'uploadDocumentFF',
    CERTIFICATION: 'certificationFF',
    FRONTAL_COURSE: 'frontalCourseFF',
    ONLINE_COURSE: 'onlineCourseFF',
    PHONE_E164_MIGRATION: 'phoneE164MigrationFF',
    BULK_USER_REFACTOR: 'bulkUserRefactorFF',
    OPERATION_MODE: 'operationModeFF',
    MUST_DO_COMPLIANCE: 'mustDoComplianceFF',
}

export const SignDocCategories = {
    FORCE_COMPLETION: 'FORCE_COMPLETION',
    CERTIFICATION: 'CERTIFICATION',
    KNOWLEDGE_CENTER: 'KNOWLEDGE_CENTER',
    OPERATION: 'OPERATION'
}

/**
 * UserSignDoc row status. ARCHIVED rows are superseded recurring versions —
 * visible to admins as read-only history, never counted toward progress.
 */
export const UserSignDocStatus = {
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED'
}

/**
 * SignDoc error codes returned from the backend
 * Used for handling specific error scenarios in the frontend
 */
export const SignDocErrorCodes = {
    SEQUENTIAL_ACTIVE_VERSION_EXISTS: 'SEQUENTIAL_ACTIVE_VERSION_EXISTS'
}

export const getAllSignDocCategories = () => {
    return [SignDocCategories.FORCE_COMPLETION, SignDocCategories.CERTIFICATION, SignDocCategories.KNOWLEDGE_CENTER, SignDocCategories.OPERATION]
}

export const MessageTypes = {
    SMS: 'SMS',
    EMAIL: 'EMAIL',
    WHATSAPP: 'WHATSAPP'
}

/**
 * Expiry duration units
 */
export const YEARS = 'years'
export const MONTHS = 'months'
export const DAYS = 'days'
export const ExpiryDurationUnits = [YEARS, MONTHS, DAYS]